import type { VersionApi } from '@ipen-portal/plugin-common';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const versionApiRef = createApiRef<VersionApi>().with({
  id: 'plugin.ipen.version.api',
});
